import { SelectOption } from "../../../molecule/inputs/select-input"
import { CSSProperties } from "react"
import PrimaryButton from "Components/atoms/buttons/primary-button"
import SearchSelect from "Components/molecule/inputs/search-select"
import { IRockQueryParam } from "models/rocks"
import SearchFormContainer from "Components/atoms/containers/search-form-container"

interface SearchRocksFormProps {
    handleChangeQuery: (key: keyof IRockQueryParam, value: any) => any,
    handleClearSearch: () => any
    style?: CSSProperties
    employees: SelectOption[]
    status: SelectOption[]
    years: SelectOption[]
    quarter: SelectOption[]
    query: IRockQueryParam
}

const SearchRocksForm = ({
    handleChangeQuery,
    handleClearSearch,
    style,
    status,
    years,
    quarter,
    employees,
    query
}: SearchRocksFormProps) => {
    return (
        <SearchFormContainer
            style={style}
            inputs={
                <>
                    <SearchSelect
                        label="Quarter"
                        options={quarter}
                        value={query.quarter}
                        onChange={(e) => handleChangeQuery("quarter", e?.value ?? "")}
                    />

                    <SearchSelect
                        label="Year"
                        options={years}
                        value={query.year}
                        onChange={(e) => handleChangeQuery("year", e?.value ?? "")}
                    />

                    <SearchSelect
                        label="Accountable"
                        options={employees}
                        value={query.accountableId}
                        onChange={(e) =>
                            handleChangeQuery("accountableId", e?.value ?? "")
                        }
                    />

                    <SearchSelect
                        label="Status"
                        options={status}
                        value={query.statusId}
                        onChange={(e) => handleChangeQuery("statusId", e?.value ?? "")}
                    />
                </>
            }
            clearSearchButton={
                <PrimaryButton onClick={handleClearSearch}>
                    Clear Search
                </PrimaryButton>
            }
        />
    )

}

export default SearchRocksForm